import React, { useEffect, useRef, useState } from "react";
import "../../Styles/CommonStyles.scss";
import { IAddress, ICreateMemberBody } from "../../store/memberInterfaceStruct";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import {
  updateMemberPrimaryAddressInfo,
  updateMemberPublishAddressInfo,
} from "../../store/memberApiSlice";
import { Button, Label } from "../../components/StyledComp/StyledComp";
import { useAppSelector } from "../../store/hooks";
import AdminUserService from "../../services/adminUserServices";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ReactModal from "react-modal";
import AddEditFirm from "./AddEditFirm";
import MemberServices from "../../services/MemberServices";
import { AnyARecord } from "dns";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface state {
  [key: string]: any;
}

interface IConfiguration {
  [key: string]: any;
}

interface IProps {
  StateList: state[];
}

const CreateMemberAddress: React.FC<IProps> = (props) => {
  const PrimaryAddress: IAddress = useSelector(
    (state: RootState) => state.memberApiSlice.PrimaryAddress
  );

  const PublishedAddress: IAddress = useSelector(
    (state: RootState) => state.memberApiSlice.PublishedAddress
  );

  const form = useForm<ICreateMemberBody>();
  const { register, control, handleSubmit, formState, setValue, clearErrors } =
    form;
  const { errors, touchedFields, dirtyFields } = formState;

  const dispatch = useDispatch();

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const [primaryFirmValidationMsg, setPrimaryFirmValidationMsg] = useState<string>("");
  const [publishedFirmValidationMsg, setPublishedFirmValidationMsg] = useState<string>("");

  const [isHandleOutsideClickTriggered, setIsHandleOutsideClickTriggered] =
    useState<boolean>(false);
  const firmListdivRef = useRef<HTMLDivElement>(null);
  const [FirmName, setFirmName] = useState<string | null>(
    typeof PrimaryAddress.FirmName! != "undefined"
      ? PrimaryAddress.FirmName!
      : ""
  );

  // const [addFirmModelOpen, setAddFirmModelOpen] = useState<boolean>(false);
  // const [editFirmModelOpen, setEditFirmModelOpen] = useState<boolean>(false);
  // PRIMARY
  const [divDisplayState, setdivDisplayState] = useState("none");
  // const [disablePriAddressInputField, setDisablePriAddressInputField] =
  // useState<boolean>(true);

  const [firmList, setFirmList] = useState<any[]>([]);
  const getFirmDetailList = async () => {
    console.log("getFirmDetailList called");
    const response = await MemberServices.getFirmDetailList();
    console.log("FirmDetailList response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Firmlist:", response.data.data);
      setFirmList(response.data.data);
      // setPubFirmList(response.data.data);
      // dispatch(updateMemberList(response.data.data));
    } else {
    }
  };

  useEffect(() => {
    getFirmDetailList();
    console.log("PLAIN useEffect:", isHandleOutsideClickTriggered);
  }, []);

  useEffect(() => {
    //Doing this to trigger validation when selecting firm
    console.log(
      "PrimaryAddress.FirmName USEEffect:",
      isHandleOutsideClickTriggered
    );
    setValue(
      "PrimaryAddress.FirmName",
      PrimaryAddress.FirmName ? PrimaryAddress.FirmName : "",
      {
        shouldDirty: true,
      }
    );

    console.log("Set PrimaryAddress.Address1-1");
    setValue(
      "PrimaryAddress.Address1",
      PrimaryAddress.Address1 ? PrimaryAddress.Address1 : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "PrimaryAddress.Address2",
      PrimaryAddress.Address2 ? PrimaryAddress.Address2 : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "PrimaryAddress.City",
      PrimaryAddress.City ? PrimaryAddress.City : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "PrimaryAddress.State",
      PrimaryAddress.State ? PrimaryAddress.State : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "PrimaryAddress.County",
      PrimaryAddress.County ? PrimaryAddress.County : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "PrimaryAddress.Zipcode",
      PrimaryAddress.Zipcode ? PrimaryAddress.Zipcode : "-",
      {
        shouldDirty: true,
      }
    );
  }, [PrimaryAddress.FirmName]);

  useEffect(() => {
    console.log(
      "USEEffect called isHandleOutsideClickTriggered:",
      isHandleOutsideClickTriggered
    );
    isHandleOutsideClickTriggered && handleOutsideClick();
  }, [isHandleOutsideClickTriggered]);

  useEffect(() => {
    console.log("USEEffect divDisplayState", isHandleOutsideClickTriggered);

    if (divDisplayState === "block") {
      console.log("EVENT ADDED");
      document.addEventListener("mousedown", updateIsHandleOutsideClickEnabled);
    } else if (divDisplayState === "none") {
      console.log("EVENT REMOVED");
      document.removeEventListener(
        "mousedown",
        updateIsHandleOutsideClickEnabled
      );
    }

    // Cleanup to ensure event is removed on unmount or when condition changes
    return () => {
      document.removeEventListener(
        "mousedown",
        updateIsHandleOutsideClickEnabled
      );
    };
  }, [divDisplayState]);

  const updateIsHandleOutsideClickEnabled = (event: MouseEvent) => {
    console.log(
      "updateIsHandleOutsideClickEnabled-start",
      isHandleOutsideClickTriggered
    );
    if (
      firmListdivRef.current &&
      !firmListdivRef.current.contains(event.target as Node)
    ) {
      setIsHandleOutsideClickTriggered(true);
    }
    console.log(
      "updateIsHandleOutsideClickEnabled-end",
      isHandleOutsideClickTriggered
    );
  };

  const handleOutsideClick = () => {
    console.log("handleOutsideClick-start:", isHandleOutsideClickTriggered);

    // Try to match with existing firms
    firmList.map((firmListItem: any) => {
      if (firmListItem.FirmName === PrimaryAddress.FirmName) {
        console.log("firmItem.FirmName === PrimaryAddress.FirmName");
        handleFirmNameClick(firmListItem);
      }
    });

    setdivDisplayState("none");
    document.removeEventListener(
      "mousedown",
      updateIsHandleOutsideClickEnabled
    );
    setIsHandleOutsideClickTriggered(false);

    // DON'T clear the field if firm doesn't exist
    // Keep the user's typed value for validation on submit
  };

  const validatePrimaryFirmName = () => {
    if (!PrimaryAddress.FirmName || PrimaryAddress.FirmName.trim() === "") {
      setPrimaryFirmValidationMsg("");
      return;
    }

    const isFirmNameExists = firmList.find(
      (firmListItem) => firmListItem.FirmName.trim().toLowerCase() === PrimaryAddress.FirmName.trim().toLowerCase()
    );

    if (!isFirmNameExists) {
      setPrimaryFirmValidationMsg("That firm will be created.");
    } else {
      setPrimaryFirmValidationMsg("");
    }
  };

  const validatePublishedFirmName = () => {
    if (!PublishedAddress.FirmName || PublishedAddress.FirmName.trim() === "") {
      setPublishedFirmValidationMsg("");
      return;
    }

    const isFirmNameExists = firmList.find(
      (firmListItem) => firmListItem.FirmName.trim().toLowerCase() === PublishedAddress.FirmName.trim().toLowerCase()
    );

    if (!isFirmNameExists) {
      setPublishedFirmValidationMsg("That firm will be created.");
    } else {
      setPublishedFirmValidationMsg("");
    }
  };

  function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // const formatPhoneNumber = (input: any) => {
  //   if (input == null) {
  //     return null;
  //   } else {
  //     let numericInputFormatted = input.replace(/\D/g, "");

  //     if (input.length > 3 && input.length <= 9) {
  //       numericInputFormatted = numericInputFormatted.replace(
  //         /(\d{3})/,
  //         "($1)"
  //       );
  //     }

  //     if (input.length > 9) {
  //       numericInputFormatted = numericInputFormatted.replace(
  //         /(\d{3})(\d{3})/,
  //         "($1) $2-"
  //       );
  //     }
  //     return numericInputFormatted;
  //   }
  // };

  const formatPhoneNumber = (input: any) => {
    if (input == null) {
      return null;
    } else {
      return input;
      // Remove all non-digit characters
      let numericInputFormatted = input.replace(/\D/g, "");

      // Apply formatting based on length
      if (numericInputFormatted.length > 6) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{3})(\d{3})(\d{0,4})/,
          "($1) $2-$3"
        );
      } else if (numericInputFormatted.length > 3) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{3})(\d{0,3})/,
          "($1) $2"
        );
      } else if (numericInputFormatted.length > 1) {
        numericInputFormatted = numericInputFormatted.replace(
          /(\d{0,3})/,
          "($1"
        );
      }

      return numericInputFormatted.trim();
    }
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    switch (event.target.name) {
      case "PrimaryAddress.FirmName":
        const priFirmName = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_PrimaryAddressFirmName(priFirmName));
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "FirmName",
            value: priFirmName,
          })
        );
        setValue("PrimaryAddress.FirmName", priFirmName, {
          shouldDirty: true,
        });
        clearErrors("PrimaryAddress.FirmName");
        break;
      case "PrimaryAddress.Address1":
        const priAddress1 = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_PrimaryAddressAddress1(priAddress1));
        console.log("Dispatch1 Address1-updateInput");
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "Address1",
            value: priAddress1,
          })
        );
        break;
      case "PrimaryAddress.Address2":
        const priAddress2 = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_PrimaryAddressAddress2(priAddress2));
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "Address2",
            value: priAddress2,
          })
        );
        break;
      case "PrimaryAddress.City":
        const priCity = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_PrimaryAddressCity(priCity));
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "City",
            value: priCity,
          })
        );
        break;
      case "PrimaryAddress.County":
        // dispatch(updateMember_PrimaryAddressCounty(event.target.value));
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "County",
            value: event.target.value,
          })
        );
        break;
      case "PrimaryAddress.Email":
        // dispatch(updateMember_PrimaryAddressEmail(event.target.value));
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "Email",
            value: event.target.value,
          })
        );
        break;
      case "PrimaryAddress.Zipcode":
        // dispatch(updateMember_PrimaryAddressZipCode(event.target.value));
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "Zipcode",
            value: event.target.value,
          })
        );
        break;
      case "PrimaryAddress.PhoneNumber":
        if (event.target.value.length < 15) {
          const formattedInput = formatPhoneNumber(event.target.value);
          // dispatch(updateMember_PrimaryAddressPhoneNumber(formattedInput));
          dispatch(
            updateMemberPrimaryAddressInfo({
              key: "PhoneNumber",
              value: formattedInput,
            })
          );
        }
        break;
      case "PrimaryAddress.CellPhoneNumber":
        if (event.target.value.length < 15) {
          const formattedInput = formatPhoneNumber(event.target.value);
          // dispatch(updateMember_PrimaryAddressCellPhoneNumber(formattedInput));
          dispatch(
            updateMemberPrimaryAddressInfo({
              key: "CellPhoneNumber",
              value: formattedInput,
            })
          );
        }
        break;
      case "PrimaryAddress.FaxNumber":
        if (event.target.value.length < 15) {
          const formattedInput = formatPhoneNumber(event.target.value);
          // dispatch(updateMember_PrimaryAddressFaxNumber(formattedInput));
          dispatch(
            updateMemberPrimaryAddressInfo({
              key: "FaxNumber",
              value: formattedInput,
            })
          );
        }
        break;
      case "PublishedAddress.FirmName":
        const pubFirmName = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_PublishAddressFirmName(pubFirmName));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "FirmName",
            value: pubFirmName,
          })
        );
        setValue("PublishedAddress.FirmName", pubFirmName, {
          shouldDirty: true,
        });
        clearErrors("PublishedAddress.FirmName");
        break;
      case "PublishedAddress.Address1":
        const pubAddress1 = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_PublishAddressAddress1(pubAddress1));
        console.log("Dispatch Publish address1 - UpdateInput");
        dispatch(
          updateMemberPublishAddressInfo({
            key: "Address1",
            value: pubAddress1,
          })
        );
        break;
      case "PublishedAddress.Address2":
        const pubAddress2 = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_PublishAddressAddress2(pubAddress2));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "Address2",
            value: pubAddress2,
          })
        );
        break;
      case "PublishedAddress.City":
        const pubCity = capitalizeFirstLetter(event.target.value);
        // dispatch(updateMember_PublishAddressCity(pubCity));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "City",
            value: pubCity,
          })
        );
        break;
      case "PublishedAddress.County":
        // dispatch(updateMember_PublishAddressCounty(event.target.value));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "County",
            value: event.target.value,
          })
        );

        break;
      case "PublishedAddress.Email":
        // dispatch(updateMember_PublishAddressEmail(event.target.value));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "Email",
            value: event.target.value,
          })
        );
        break;
      case "PublishedAddress.Zipcode":
        // dispatch(updateMember_PublishAddressZipCode(event.target.value));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "Zipcode",
            value: event.target.value,
          })
        );
        break;
      case "PublishedAddress.PhoneNumber":
        if (event.target.value.length < 15) {
          const formattedInput = formatPhoneNumber(event.target.value);
          // dispatch(updateMember_PublishAddressPhoneNumber(formattedInput));
          dispatch(
            updateMemberPublishAddressInfo({
              key: "PhoneNumber",
              value: formattedInput,
            })
          );
        }
        break;
      case "PublishedAddress.CellPhoneNumber":
        if (event.target.value.length < 15) {
          const formattedInput = formatPhoneNumber(event.target.value);
          // dispatch(updateMember_PublishAddressCellPhoneNumber(formattedInput));
          dispatch(
            updateMemberPublishAddressInfo({
              key: "CellPhoneNumber",
              value: formattedInput,
            })
          );
        }
        break;
      case "PublishedAddress.FaxNumber":
        if (event.target.value.length < 15) {
          const formattedInput = formatPhoneNumber(event.target.value);
          // dispatch(updateMember_PublishAddressFaxNumber(formattedInput));
          dispatch(
            updateMemberPublishAddressInfo({
              key: "FaxNumber",
              value: formattedInput,
            })
          );
        }
        break;
      case "PublishedAddress.FirmAdminName":
        // dispatch(updateMember_PublishAddressFirmAdminName(event.target.value));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "FirmAdminName",
            value: event.target.value,
          })
        );
        break;
      case "PublishedAddress.AdminPhoneNumber":
        if (event.target.value.length < 15) {
          const formattedInput = formatPhoneNumber(event.target.value);
          // dispatch(updateMember_PublishAddressAdminPhoneNumber(formattedInput));
          dispatch(
            updateMemberPublishAddressInfo({
              key: "AdminPhoneNumber",
              value: formattedInput,
            })
          );
        }
        break;
      case "PublishedAddress.FirmAdminEmailId":
        // dispatch(updateMember_PublishAddressAdminEmailId(event.target.value));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "FirmAdminEmailId",
            value: event.target.value,
          })
        );
        break;
      default:
        break;
    }
  };

  const updateSelectBox = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    switch (event.target.name) {
      case "PrimaryAddress.State":
        // dispatch(updateMember_PrimaryAddressState(event.target.value));
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "State",
            value: event.target.value,
          })
        );
        break;
      case "PrimaryAddress.County":
        // dispatch(updateMember_PrimaryAddressCounty(event.target.value));
        dispatch(
          updateMemberPrimaryAddressInfo({
            key: "County",
            value: event.target.value,
          })
        );
        break;
      case "PublishedAddress.State":
        // dispatch(updateMember_PublishAddressState(event.target.value));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "State",
            value: event.target.value,
          })
        );
        break;
      case "PublishedAddress.County":
        // dispatch(updateMember_PublishAddressCounty(event.target.value));
        dispatch(
          updateMemberPublishAddressInfo({
            key: "County",
            value: event.target.value,
          })
        );
        break;
      default:
        console.log("default case");
        break;
    }
  };

  const handleFirmNameClick = (newFirm: any) => {
    console.log("handleFirmNameClick CALLED:", newFirm);
    setdivDisplayState("none");
    // setDisablePriAddressInputField(true);

    // dispatch(
    //   updateMember_PrimaryAddressFirmName(
    //     newFirm.FirmName ? newFirm.FirmName : "-"
    //   )
    // );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "FirmName",
        value: newFirm.FirmName ? newFirm.FirmName : "",
      })
    );

    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "Id",
        value: newFirm.Id ? newFirm.Id : "",
      })
    );
    // dispatch(
    //   updateMember_PrimaryAddressAddress1(
    //     newFirm.Address1 ? newFirm.Address1 : "-"
    //   )
    // );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "Address1",
        value: newFirm.Address1 ? newFirm.Address1 : "",
      })
    );
    // dispatch(
    //   updateMember_PrimaryAddressAddress2(
    //     newFirm.Address2 ? newFirm.Address2 : "-"
    //   )
    // );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "Address2",
        value: newFirm.Address2 ? newFirm.Address2 : "",
      })
    );
    // dispatch(
    //   updateMember_PrimaryAddressCity(newFirm.City ? newFirm.City : "-")
    // );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "City",
        value: newFirm.City ? newFirm.City : "",
      })
    );
    // dispatch(
    //   updateMember_PrimaryAddressCounty(newFirm.County ? newFirm.County : "-")
    // );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "County",
        value: newFirm.County ? newFirm.County : "",
      })
    );
    // dispatch(
    //   updateMember_PrimaryAddressState(newFirm.State ? newFirm.State : "-")
    // );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "State",
        value: newFirm.State ? newFirm.State : "",
      })
    );
    // dispatch(
    //   updateMember_PrimaryAddressZipCode(
    //     newFirm.Zipcode ? newFirm.Zipcode : "-"
    //   )
    // );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "Zipcode",
        value: newFirm.Zipcode ? newFirm.Zipcode : "",
      })
    );
    console.log("setDirsty");
    setValue("PrimaryAddress.FirmName", newFirm.FirmName, {
      shouldDirty: true,
    });
    clearErrors("PrimaryAddress.FirmName");
  };

  const clearFormPrimary = () => {
    console.log("Clear form called..");
    // dispatch(resetPrimaryAddress());
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "Address1",
        value: "",
      })
    );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "Address2",
        value: "",
      })
    );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "City",
        value: "",
      })
    );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "County",
        value: "",
      })
    );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "State",
        value: "",
      })
    );
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "Zipcode",
        value: "",
      })
    );
    // dispatch(updateMember_PrimaryAddressAddress1(""));
    // dispatch(updateMember_PrimaryAddressAddress2(""));
    // dispatch(updateMember_PrimaryAddressCity(""));
    // dispatch(updateMember_PrimaryAddressCounty(""));
    // dispatch(updateMember_PrimaryAddressState(""));
    // dispatch(updateMember_PrimaryAddressZipCode(""));
  };

  const updateFirmInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const inputValue = event.target.value;

    // ALWAYS update the state - allow typing new firm names
    dispatch(
      updateMemberPrimaryAddressInfo({
        key: "FirmName",
        value: inputValue,
      })
    );
    setFirmName(inputValue);
    setValue("PrimaryAddress.FirmName", inputValue, {
      shouldDirty: true,
    });
    clearErrors("PrimaryAddress.FirmName");

    // Show dropdown only if matching firms exist
    const hasMatches = firmList.some((firmListItem) =>
      firmListItem.FirmName.trim().toLowerCase().startsWith(inputValue.trim().toLowerCase())
    );

    if (hasMatches && inputValue.trim() !== "") {
      setdivDisplayState("block");
    }

    // const firmFound = firmList.find(
    //   (firmListItem: any) => firmListItem.FirmName === event.target.value
    // );

    // if (firmFound) {
    //   setDisablePriAddressInputField(true);
    // } else {
    //   setDisablePriAddressInputField(false);
    //   console.log("before clear form");
    //   clearForm();
    // }
  };

  const handleFirmFieldClick = (event: React.MouseEvent<HTMLElement>): void => {
    setdivDisplayState("block");
  };

  // PUBLISH

  const [divPubDisplayState, setDivPubDisplayState] = useState("none");
  // const [disablePubAddressInputField, setDisablePubAddressInputField] =
  //   useState<boolean>(true);
  // const [pubFirmList, setPubFirmList] = useState<any[]>([]);
  const [pubFirmName, setPubFirmName] = useState<string | null>(
    typeof PublishedAddress.FirmName! != "undefined"
      ? PublishedAddress.FirmName!
      : ""
  );

  // const [pubFirmAdminName, setPubFirmAdminName = useState<string | null>(
  //   typeof PublishedAddress.FirmAdminName! != "undefined"
  //     ? PublishedAddress.FirmAdminName!
  //     : ""
  // );
  // const [pubFirmAdminPhoneNumber, setPubFirmAdminPhoneNumber] = useState<string | null>(
  //   typeof PublishedAddress.FirmAdminPhoneNumber! != "undefined"
  //     ? PublishedAddress.FirmAdminPhoneNumber!
  //     : ""
  // );
  // const [pubFirmAdminEmailId, setPubFirmAdminEmailId] = useState<string | null>(
  //   typeof PublishedAddress.FirmAdminEmailId! != "undefined"
  //     ? PublishedAddress.FirmAdminEmailId!
  //     : ""
  // );
  const [isPubHandleOutsideClickEnabled, setIsPubHandleOutsideClickEnabled] =
    useState<boolean>(false);
  const firmListdivPubRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    //Doing this to trigger validation when selecting firm

    setValue(
      "PublishedAddress.FirmName",
      PublishedAddress.FirmName ? PublishedAddress.FirmName : "",
      {
        shouldDirty: true,
      }
    );

    setValue(
      "PublishedAddress.Address1",
      PublishedAddress.Address1 ? PublishedAddress.Address1 : "",
      {
        shouldDirty: true,
      }
    );

    setValue(
      "PublishedAddress.Address2",
      PublishedAddress.Address2 ? PublishedAddress.Address2 : "",
      {
        shouldDirty: true,
      }
    );

    setValue(
      "PublishedAddress.City",
      PublishedAddress.City ? PublishedAddress.City : "-",
      {
        shouldDirty: true,
      }
    );

    setValue(
      "PublishedAddress.County",
      PublishedAddress.County ? PublishedAddress.County : "-",
      {
        shouldDirty: true,
      }
    );

    setValue(
      "PublishedAddress.State",
      PublishedAddress.State ? PublishedAddress.State : "-",
      {
        shouldDirty: true,
      }
    );
    setValue(
      "PublishedAddress.Zipcode",
      PublishedAddress.Zipcode ? PublishedAddress.Zipcode : "-",
      {
        shouldDirty: true,
      }
    );
  }, [PublishedAddress.FirmName]);

  useEffect(() => {
    console.log(
      "use effect isPubHandleOutsideClickEnabled:",
      isPubHandleOutsideClickEnabled
    );
    isPubHandleOutsideClickEnabled && pubHandleOutsideClick();
  }, [isPubHandleOutsideClickEnabled]);

  useEffect(() => {
    console.log("USEEffect divDisplayState", isHandleOutsideClickTriggered);

    if (divPubDisplayState === "block") {
      console.log("EVENT ADDED");
      document.addEventListener(
        "mousedown",
        updateIsPubHandleOutsideClickEnabled
      );
    } else if (divPubDisplayState === "none") {
      console.log("EVENT REMOVED");
      document.removeEventListener(
        "mousedown",
        updateIsPubHandleOutsideClickEnabled
      );
    }

    // Cleanup to ensure event is removed on unmount or when condition changes
    return () => {
      document.removeEventListener(
        "mousedown",
        updateIsPubHandleOutsideClickEnabled
      );
    };
  }, [divPubDisplayState]);

  const updateIsPubHandleOutsideClickEnabled = (event: MouseEvent) => {
    console.log("Pub updateIsHandleOutsideClickEnabled");
    if (
      firmListdivPubRef.current &&
      !firmListdivPubRef.current.contains(event.target as Node)
    ) {
      console.log("Setting setIsPubHandleOutsideClickEnabled");
      setIsPubHandleOutsideClickEnabled(true);
    }
  };

  const pubHandleOutsideClick = () => {
    console.log("pub-handleOutsideClick-FirmName:", PublishedAddress.FirmName);

    // Try to match with existing firms
    firmList.map((firmListItem) => {
      if (firmListItem.FirmName === PublishedAddress.FirmName) {
        pubHandleFirmNameClick(firmListItem);
      }
    });

    setDivPubDisplayState("none");
    document.removeEventListener(
      "mousedown",
      updateIsHandleOutsideClickEnabled
    );
    setIsPubHandleOutsideClickEnabled(false);

    // DON'T clear the field if firm doesn't exist
    // Keep the user's typed value for validation on submit
  };

  const pubUpdateFirmInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const inputValue = event.target.value;

    // ALWAYS update the state - allow typing new firm names
    dispatch(
      updateMemberPublishAddressInfo({
        key: "FirmName",
        value: inputValue,
      })
    );
    setPubFirmName(inputValue);
    setValue("PublishedAddress.FirmName", inputValue, {
      shouldDirty: true,
    });
    clearErrors("PublishedAddress.FirmName");

    // Show dropdown only if matching firms exist
    const hasMatches = firmList.some((firmListItem) =>
      firmListItem.FirmName.trim().toLowerCase().startsWith(inputValue.trim().toLowerCase())
    );

    if (hasMatches && inputValue.trim() !== "") {
      setDivPubDisplayState("block");
    }

    // moved this from useEffect to here
    // document.addEventListener(
    //   "mousedown",
    //   updateIsPubHandleOutsideClickEnabled
    // );
    // props.FirmList.some((firmListItem) => {
    //   if (firmListItem.FirmName === event.target.value) {
    //     setDisablePubAddressInputField(true);
    //     return true;
    //   } else {
    //     setDisablePubAddressInputField(false);
    //     pubClearForm();
    //   }
    // });

    // const firmFound = firmList.find(
    //   (firmListItem) => firmListItem.FirmName === event.target.value
    // );

    // if (firmFound) {
    //   setDisablePubAddressInputField(true);
    // } else {
    //   // setDisablePubAddressInputField(false);
    //   console.log("before clear form");
    //   pubClearForm();
    // }
  };

  const pubHandleFirmNameClick = (newFirm: any) => {
    console.log("pub handleFirmNameClick CALLED:", newFirm);
    setDivPubDisplayState("none");
    // setDisablePubAddressInputField(true);

    // dispatch(
    //   updateMember_PublishAddressFirmName(
    //     newFirm.FirmName ? newFirm.FirmName : "-"
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "FirmName",
        value: newFirm.FirmName ? newFirm.FirmName : "-",
      })
    );

    dispatch(
      updateMemberPublishAddressInfo({
        key: "Id",
        value: newFirm.Id ? newFirm.Id : "-",
      })
    );

    // dispatch(
    //   updateMember_PublishAddressAddress1(
    //     newFirm.Address1 ? newFirm.Address1 : "-"
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Address1",
        value: newFirm.Address1 ? newFirm.Address1 : "-",
      })
    );

    // dispatch(
    //   updateMember_PublishAddressAddress2(
    //     newFirm.Address2 ? newFirm.Address2 : "-"
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Address2",
        value: newFirm.Address2 ? newFirm.Address2 : "-",
      })
    );

    // dispatch(
    //   updateMember_PublishAddressCity(newFirm.City ? newFirm.City : "-")
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "City",
        value: newFirm.City ? newFirm.City : "-",
      })
    );

    // dispatch(
    //   updateMember_PublishAddressCounty(newFirm.County ? newFirm.County : "-")
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "County",
        value: newFirm.County ? newFirm.County : "-",
      })
    );

    // dispatch(
    //   updateMember_PublishAddressState(newFirm.State ? newFirm.State : "-")
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "State",
        value: newFirm.State ? newFirm.State : "-",
      })
    );

    // dispatch(
    //   updateMember_PublishAddressZipCode(
    //     newFirm.Zipcode ? newFirm.Zipcode : "-"
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Zipcode",
        value: newFirm.Zipcode ? newFirm.Zipcode : "-",
      })
    );

    dispatch(
      updateMemberPublishAddressInfo({
        key: "FirmAdminEmailId",
        value: newFirm.FirmAdminEmailId ? newFirm.FirmAdminEmailId : "-",
      })
    );

    dispatch(
      updateMemberPublishAddressInfo({
        key: "FirmAdminName",
        value: newFirm.FirmAdminName ? newFirm.FirmAdminName : "-",
      })
    );

    dispatch(
      updateMemberPublishAddressInfo({
        key: "FirmAdminPhoneNumber",
        value: newFirm.FirmAdminPhoneNumber
          ? newFirm.FirmAdminPhoneNumber
          : "-",
      })
    );

    console.log("setDirty");
    setValue("PublishedAddress.FirmName", newFirm.FirmName, {
      shouldDirty: true,
    });
    clearErrors("PublishedAddress.FirmName");
  };

  const pubClearForm = () => {
    console.log("Clear form called..");
    // dispatch(updateMember_PublishAddressAddress1(""));
    // dispatch(updateMember_PublishAddressAddress2(""));
    // dispatch(updateMember_PublishAddressCity(""));
    // dispatch(updateMember_PublishAddressCounty(""));
    // dispatch(updateMember_PublishAddressState(""));
    // dispatch(updateMember_PublishAddressZipCode(""));
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Address1",
        value: "",
      })
    );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Address2",
        value: "",
      })
    );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "City",
        value: "",
      })
    );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "County",
        value: "",
      })
    );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "State",
        value: "",
      })
    );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Zipcode",
        value: "",
      })
    );
  };

  const pubHandleFirmFieldClick = (
    event: React.MouseEvent<HTMLElement>
  ): void => {
    setDivPubDisplayState("block");
  };

  const copyFromPublishedAddress = () => {
    // dispatch(
    //   updateMember_PublishAddressFirmName(
    //     createMemberBody.PrimaryAddress.FirmName
    //   )
    // );
    console.log("PrimaryAddress?.FirmId:", PrimaryAddress?.Id);
    if (PrimaryAddress?.Id != null) {
      const selectedFirm = firmList.find(
        (firm: IAddress) => firm?.Id == PrimaryAddress?.Id
      );
      console.log("selectedFirm:", selectedFirm);
      if (selectedFirm) {
        dispatch(
          updateMemberPublishAddressInfo({
            key: "FirmAdminEmailId",
            value: selectedFirm.FirmAdminEmailId
              ? selectedFirm.FirmAdminEmailId
              : "-",
          })
        );

        dispatch(
          updateMemberPublishAddressInfo({
            key: "FirmAdminName",
            value: selectedFirm.FirmAdminName ? selectedFirm.FirmAdminName : "-",
          })
        );

        dispatch(
          updateMemberPublishAddressInfo({
            key: "FirmAdminPhoneNumber",
            value: selectedFirm.FirmAdminPhoneNumber
              ? selectedFirm.FirmAdminPhoneNumber
              : "-",
          })
        );
      }
    }

    dispatch(
      updateMemberPublishAddressInfo({
        key: "Id",
        value: PrimaryAddress.Id,
      })
    );

    dispatch(
      updateMemberPublishAddressInfo({
        key: "FirmName",
        value: PrimaryAddress.FirmName,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressAddress1(
    //     createMemberBody.PrimaryAddress.Address1
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Address1",
        value: PrimaryAddress.Address1,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressAddress2(
    //     createMemberBody.PrimaryAddress.Address2
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Address2",
        value: PrimaryAddress.Address2,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressCity(createMemberBody.PrimaryAddress.City)
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "City",
        value: PrimaryAddress.City,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressCounty(createMemberBody.PrimaryAddress.County)
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "County",
        value: PrimaryAddress.County,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressState(createMemberBody.PrimaryAddress.State)
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "State",
        value: PrimaryAddress.State,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressZipCode(
    //     createMemberBody.PrimaryAddress.Zipcode
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Zipcode",
        value: PrimaryAddress.Zipcode,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressPhoneNumber(
    //     createMemberBody.PrimaryAddress.PhoneNumber
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "PhoneNumber",
        value: PrimaryAddress.PhoneNumber,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressCellPhoneNumber(
    //     createMemberBody.PrimaryAddress.CellPhoneNumber
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "CellPhoneNumber",
        value: PrimaryAddress.CellPhoneNumber,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressFaxNumber(
    //     createMemberBody.PrimaryAddress.FaxNumber
    //   )
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "FaxNumber",
        value: PrimaryAddress.FaxNumber,
      })
    );

    // dispatch(
    //   updateMember_PublishAddressEmail(createMemberBody.PrimaryAddress.Email)
    // );
    dispatch(
      updateMemberPublishAddressInfo({
        key: "Email",
        value: PrimaryAddress.Email,
      })
    );
  };

  return (
    <>
      <>
        <div className="section-box">
          <h3 className="section-heading">Primary Address</h3>
          <div className="form-wrapper">
            <div
              className="input-field-div-wrapper"
              style={{
                position: "relative",
                borderColor: "var(--active-border-color)",
              }}
            >
              {/* <Label>Firm Name</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PrimaryAddress.FirmName"
                {...register("PrimaryAddress.FirmName", {
                  // required: "Firm Name is a required field",
                })}
                value={
                  typeof PrimaryAddress.FirmName! != "undefined"
                    ? PrimaryAddress.FirmName!
                    : ""
                }
                // onChange={updateInput}
                disabled={false}
                onChange={updateFirmInput}
                onBlur={validatePrimaryFirmName}
                autoComplete="off"
                onClick={handleFirmFieldClick}
              />
              <label className="form-label" htmlFor="PrimaryAddress.FirmName">
                Select Firm Name
              </label>
              <p className="form-error form-error-position" style={{ color: primaryFirmValidationMsg ? "green" : "red" }}>
                {primaryFirmValidationMsg || errors?.PrimaryAddress?.FirmName?.message}
              </p>

              <div
                className="suggestion-dropdown"
                style={{
                  position: "absolute",
                  display: divDisplayState,
                  width: "150%",
                }}
                ref={firmListdivRef}
              >
                {firmList
                  ?.filter((item: any) => {
                    return item.FirmName != null;
                  })
                  .filter((item: any) => {
                    return FirmName
                      ? item.FirmName.toLowerCase().startsWith(
                          FirmName.toLowerCase()
                        )
                      : item.FirmName;
                  })
                  .map((item: any) => (
                    <div
                      className="suggested-item-row"
                      key={item.Id}
                      onClick={(event) => handleFirmNameClick(item)}
                    >
                      {item.FirmName}
                      {", "}
                      {item.City}
                    </div>
                  ))}
              </div>
            </div>
            <div className="input-addressfield-div mt-2">
              <input
                className="input-field-div-small"
                placeholder=""
                id="PrimaryAddress.Address1"
                name="PrimaryAddress.Address1"
                // {...register("Address1", {
                //   required: "Address is a required field",
                // })}
                autoComplete="off"
                // disabled={disablePriAddressInputField}
                value={
                  typeof PrimaryAddress.Address1! != "undefined"
                    ? PrimaryAddress.Address1!
                    : ""
                }
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PrimaryAddress.Address1">
                Address 1
              </label>
              <p className="form-error form-error-position">
                {errors?.PrimaryAddress?.Address1?.message}
              </p>
            </div>
            <div className="input-addressfield-div">
              {/* <Label>Address 2</Label> */}
              <input
                className="input-field-div-small"
                id="PrimaryAddress.Address2"
                placeholder=""
                name="PrimaryAddress.Address2"
                autoComplete="off"
                // disabled={disablePriAddressInputField}
                value={
                  typeof PrimaryAddress.Address2! != "undefined"
                    ? PrimaryAddress.Address2!
                    : ""
                }
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PrimaryAddress.Address2">
                Address 2
              </label>
            </div>
            <div className="input-field-div-wrapper">
              {/* <Label>City</Label> */}
              <input
                className="input-field-div-small"
                id="PrimaryAddress.City"
                name="PrimaryAddress.City"
                placeholder=""
                autoComplete="off"
                // disabled={disablePriAddressInputField}
                value={
                  typeof PrimaryAddress.City! != "undefined"
                    ? PrimaryAddress.City!
                    : ""
                }
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PrimaryAddress.City">
                City
              </label>
            </div>

            <div className="input-field-div-wrapper">
              {/* <div className="selectfield-label">Title</div> */}
              <select
                className="dropdown-control-large-insidetextfield"
                name="PrimaryAddress.County"
                // onChange={(e) => {
                //   updateSelectBox(e);
                // }}
                // disabled={
                //   disablePriAddressInputField
                //     ? errors?.PrimaryAddress?.County?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                onChange={updateSelectBox}
                value={
                  typeof PrimaryAddress.County! != "undefined"
                    ? PrimaryAddress.County!
                    : ""
                }
              >
                <option value={""}> Select County </option>
                <option value="New Castle">New Castle</option>
                <option value="Kent">Kent</option>
                <option value="Sussex">Sussex</option>
                <option value="Out Of State">Out Of State</option>
              </select>
              {/* <p className="form-error form-error-position">{errors.Title?.message}</p> */}
            </div>

            <div className="input-field-div-wrapper">
              {/* <div className="selectfield-label">State</div> */}
              <select
                className="dropdown-control-large-insidetextfield"
                name="PrimaryAddress.State"
                // {...register("State", {
                //   required: "State is a required field",
                // })}
                // disabled={disablePriAddressInputField}
                // disabled={
                //   disablePriAddressInputField
                //     ? errors.PrimaryAddress?.State?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                onChange={updateSelectBox}
                value={PrimaryAddress.State ?? ""}
              >
                <option value={""}> Select State </option>
                {props.StateList?.map((State: any) => (
                  <option key={State.Id} value={State.StateName}>
                    {State.StateName}
                  </option>
                ))}
                ;
              </select>
              <p className="form-error  form-error-position">
                {errors?.PrimaryAddress?.State?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper">
              {/* <Label>Zip Code</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PrimaryAddress.Zipcode"
                name="PrimaryAddress.Zipcode"
                // {...register("Zipcode", {
                //   required: "Zipcode is a required field",
                // })}
                autoComplete="off"
                // disabled={disablePriAddressInputField}
                // FirmName : 60 Degrees Group has text in zipcode. so diable this
                // type="number"
                pattern="[a-zA-Z0-9]*"
                value={
                  typeof PrimaryAddress.Zipcode! != "undefined"
                    ? PrimaryAddress.Zipcode!
                    : ""
                }
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PrimaryAddress.Zipcode">
                Zip Code
              </label>
              <p className="form-error  form-error-position">
                {errors?.PrimaryAddress?.Zipcode?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper">
              {/* <Label>Phone Number</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PrimaryAddress.PhoneNumber"
                // name="PhoneNumber"
                {...register("PrimaryAddress.PhoneNumber", {
                  // required: "PhoneNumber is a required field",
                  // minLength: {
                  //   value: 11,
                  //   message: "Miminum 9 digit is required",
                  // },
                  maxLength: {
                    value: 14,
                    message: "Maximum 10 digit is allowed",
                  },
                })}
                autoComplete="off"
                type="text"
                pattern="[0-9]*"
                value={
                  typeof PrimaryAddress.PhoneNumber! != "undefined"
                    ? PrimaryAddress.PhoneNumber!
                    : ""
                }
                onChange={updateInput}
              />
              <label
                className="form-label"
                htmlFor="PrimaryAddress.PhoneNumber"
              >
                Phone Number
              </label>
              <p className="form-error  form-error-position">
                {errors?.PrimaryAddress?.PhoneNumber?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper">
              <input
                className="input-field-div-small"
                placeholder=""
                id="PrimaryAddress.CellPhoneNumber"
                // name="PhoneNumber"
                {...register("PrimaryAddress.CellPhoneNumber", {
                  // required: "PhoneNumber is a required field",
                  // minLength: {
                  //   value: 11,
                  //   message: "Miminum 9 digit is required",
                  // },
                  maxLength: {
                    value: 14,
                    message: "Maximum 10 digit is allowed",
                  },
                })}
                autoComplete="off"
                type="text"
                pattern="[0-9]*"
                value={
                  typeof PrimaryAddress.CellPhoneNumber! != "undefined"
                    ? PrimaryAddress.CellPhoneNumber!
                    : ""
                }
                onChange={updateInput}
              />
              <label
                className="form-label"
                htmlFor="PrimaryAddress.CellPhoneNumber"
              >
                Cell Phone Number
              </label>
              <p className="form-error  form-error-position">
                {errors?.PrimaryAddress?.CellPhoneNumber?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper">
              {/* <Label>Fax Number</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PrimaryAddress.FaxNumber"
                {...register("PrimaryAddress.FaxNumber", {
                  //   pattern: {
                  //     value: /^\d{10}$/,
                  //     message: "Please enter a valid 10-digit phone number",
                  // },
                  // required: "PhoneNumber is a required field",
                  // minLength: {
                  //   value: 11,
                  //   message: "Miminum 9 digit is required",
                  // },
                  maxLength: {
                    value: 14,
                    message: "Maximum 10 digit is allowed",
                  },
                })}
                autoComplete="off"
                type="text"
                pattern="[0-9]*"
                value={
                  typeof PrimaryAddress.FaxNumber! != "undefined"
                    ? PrimaryAddress.FaxNumber!
                    : ""
                }
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PrimaryAddress.FaxNumber">
                Fax Number
              </label>
            </div>
            <div className="input-field-div-wrapper">
              {/* <Label>Email ID</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                {...register("PrimaryAddress.Email", {
                  required: false,
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address",
                  },
                })}
                id="PrimaryAddress.Email"
                name="PrimaryAddress.Email"
                // {...register("Email", {
                //   required: "Email is a required field",
                // })}
                autoComplete="off"
                value={
                  typeof PrimaryAddress.Email! != "undefined"
                    ? PrimaryAddress.Email!
                    : ""
                }
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PrimaryAddress.Email">
                Email ID
              </label>
              <p className="form-error form-error-position">
                {errors?.PrimaryAddress?.Email?.message}
              </p>
            </div>
          </div>
        </div>
        {/* <DevTool control={control} /> */}
      </>
      <>
        <div className="section-box">
          <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-between">
              <h3 className="section-heading">Published Address</h3>
              {/* comments: not implementing Add firm here as there is challenge in field validation
              and lack of time. user can do it in firm management section  */}
              {/* <div className="settings-add-button ms-4">
                <div
                  className="secondary-button"
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                  onClick={() => setAddFirmModelOpen(true)}
                >
                  <AddCircleOutlineIcon></AddCircleOutlineIcon>
                  <span className="ps-1">Add Firm</span>
                </div>
              </div> */}
              {/* <div className="settings-add-button ms-4">
                <div
                  className="secondary-button"
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                  onClick={() => {
                    if (
                      PublishedAddress.Id === null ||
                      PublishedAddress.Id === undefined
                    ) {
                      alert("Please selected a firm to edit");
                      return;
                    }
                    setEditFirmModelOpen(true);
                  }}
                >
                  <EditIcon></EditIcon>
                  <span className="ps-1">Edit Firm</span>
                </div>
              </div> */}
            </div>
            <button
              type="button"
              className="p-1 rounded bg-color"
              style={{ background: "#366287", color: "white" }}
              onClick={copyFromPublishedAddress}
            >
              Copy from Primary Address
            </button>
          </div>
          <div className="form-wrapper">
            <div
              className="input-field-div-wrapper"
              style={{
                position: "relative",
                borderColor: "var(--active-border-color)",
              }}
            >
              {/* <Label>Firm Name</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.FirmName"
                {...register("PublishedAddress.FirmName", {
                  // required: "Firm Name is a required field",
                })}
                value={
                  PublishedAddress && PublishedAddress.FirmName
                    ? PublishedAddress.FirmName!
                    : ""
                }
                // onChange={updateInput}
                disabled={false}
                onChange={pubUpdateFirmInput}
                onBlur={validatePublishedFirmName}
                autoComplete="off"
                onClick={pubHandleFirmFieldClick}
              />
              <label className="form-label" htmlFor="PublishedAddress.FirmName">
                Select Firm Name
              </label>
              <p className="form-error form-error-position" style={{ color: publishedFirmValidationMsg ? "green" : "red" }}>
                {publishedFirmValidationMsg || errors.PublishedAddress?.FirmName?.message}
              </p>
              <div
                className="suggestion-dropdown"
                style={{
                  position: "absolute",
                  display: divPubDisplayState,
                  width: "150%",
                }}
                ref={firmListdivPubRef}
              >
                {firmList
                  ?.filter((item: any) => {
                    return item.FirmName != null;
                  })
                  .filter((item: any) => {
                    return pubFirmName
                      ? item.FirmName.toLowerCase().startsWith(
                          pubFirmName.toLowerCase()
                        )
                      : item.FirmName;
                  })
                  .map((item: any) => (
                    <div
                      className="suggested-item-row"
                      key={item.Id}
                      onClick={(event) => pubHandleFirmNameClick(item)}
                    >
                      {item.FirmName}
                      {", "}
                      {item.City}
                    </div>
                  ))}
              </div>
            </div>

            <div className="input-addressfield-div mt-2">
              {/* <Label>Address 1</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.Address1"
                {...register("PublishedAddress.Address1", {
                  // required: "Address is a required field"
                })}
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.Address1?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                value={
                  typeof PublishedAddress.Address1! != "undefined"
                    ? PublishedAddress.Address1!
                    : ""
                }
                onChange={updateInput}
                autoComplete="off"
                // onClick={handleFirmFieldClick}
              />
              <label className="form-label" htmlFor="PublishedAddress.Address1">
                Address 1
              </label>
            </div>
            <div className="input-addressfield-div">
              {/* <Label>Address 2</Label> */}
              <input
                className="input-field-div-small"
                id="PublishedAddress.Address2"
                placeholder=""
                name="PublishedAddress.Address2"
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.Address2?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                value={
                  typeof PublishedAddress.Address2! != "undefined"
                    ? PublishedAddress.Address2!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PublishedAddress.Address2">
                Address 2
              </label>
            </div>
            <div className="input-field-div-wrapper">
              {/* <Label>City</Label> */}
              <input
                className="input-field-div-small"
                id="PublishedAddress.City"
                name="PublishedAddress.City"
                placeholder=""
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.City?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                value={
                  typeof PublishedAddress.City! != "undefined"
                    ? PublishedAddress.City!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PublishedAddress.City">
                City
              </label>
            </div>
            <div className="input-field-div-wrapper">
              {/* <div className="selectfield-label">Title</div> */}
              <select
                className="dropdown-control-large-insidetextfield"
                name="PublishedAddress.County"
                // onChange={(e) => {
                //   updateSelectBox(e);
                // }}
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.County?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                onChange={updateSelectBox}
                value={
                  typeof PublishedAddress.County! != "undefined"
                    ? PublishedAddress.County!
                    : ""
                }
              >
                <option value={""}> Select County </option>
                <option value="New Castle">New Castle</option>
                <option value="Kent">Kent</option>
                <option value="Sussex">Sussex</option>
                <option value="Out Of State">Out Of State</option>
              </select>
              {/* <p className="form-error form-error-position">{errors.Title?.message}</p> */}
            </div>

            <div className="input-field-div-wrapper">
              {/* <div className="selectfield-label">State</div> */}
              <select
                className="dropdown-control-large-insidetextfield"
                {...register("PublishedAddress.State", {
                  // required: "State is a required field",
                })}
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.State?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                autoComplete="off"
                onChange={updateSelectBox}
                value={PublishedAddress.State ?? ""}
              >
                <option value={""}> Select State </option>
                {props.StateList?.map((State: any) => (
                  <option key={State.Id} value={State.StateName}>
                    {State.StateName}
                  </option>
                ))}
                ;
              </select>
              <p className="form-error form-error-position">
                {errors.PublishedAddress?.State?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper">
              {/* <Label>Zip Code</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.Zipcode"
                {...register("PublishedAddress.Zipcode", {
                  // required: "Zipcode is a required field",
                })}
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.Zipcode?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                type="number"
                pattern="[0-9]*"
                value={
                  typeof PublishedAddress.Zipcode! != "undefined"
                    ? PublishedAddress.Zipcode!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
                // onClick={handleFirmFieldClick}
              />
              <label className="form-label" htmlFor="PublishedAddress.Zipcode">
                Zip Code
              </label>
              <p className="form-error form-error-position">
                {errors.PublishedAddress?.Zipcode?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper">
              {/* <Label>Phone Number</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.PhoneNumber"
                {...register("PublishedAddress.PhoneNumber", {
                  // required: "PhoneNumber is a required field",
                  // minLength: {
                  //   value: 11,
                  //   message: "Miminum 9 digit is required",
                  // },
                  maxLength: {
                    value: 14,
                    message: "Maximum 10 digit is allowed",
                  },
                })}
                type="text"
                pattern="[0-9]*"
                value={
                  typeof PublishedAddress.PhoneNumber! != "undefined"
                    ? PublishedAddress.PhoneNumber!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
                // onClick={handleFirmFieldClick}
              />
              <label
                className="form-label"
                htmlFor="PublishedAddress.PhoneNumber"
              >
                Phone Number
              </label>
              <p className="form-error form-error-position">
                {errors.PublishedAddress?.PhoneNumber?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper">
              {/* <Label>Phone Number</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.CellPhoneNumber"
                {...register("PublishedAddress.CellPhoneNumber", {
                  // required: "PhoneNumber is a required field",
                  // minLength: {
                  //   value: 11,
                  //   message: "Miminum 9 digit is required",
                  // },
                  maxLength: {
                    value: 14,
                    message: "Maximum 10 digit is allowed",
                  },
                })}
                type="text"
                pattern="[0-9]*"
                value={
                  typeof PublishedAddress.CellPhoneNumber! != "undefined"
                    ? PublishedAddress.CellPhoneNumber!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
                // onClick={handleFirmFieldClick}
              />
              <label
                className="form-label"
                htmlFor="PublishedAddress.CellPhoneNumber"
              >
                Cell Phone Number
              </label>
              <p className="form-error form-error-position">
                {errors.PublishedAddress?.CellPhoneNumber?.message}
              </p>
            </div>

            <div className="input-field-div-wrapper">
              {/* <Label>Fax Number</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.FaxNumber"
                {...register("PublishedAddress.FaxNumber", {
                  // required: "PhoneNumber is a required field",
                  // minLength: {
                  //   value: 11,
                  //   message: "Miminum 9 digit is required",
                  // },
                  maxLength: {
                    value: 14,
                    message: "Maximum 10 digit is allowed",
                  },
                })}
                autoComplete="off"
                type="text"
                pattern="[0-9]*"
                value={
                  typeof PublishedAddress.FaxNumber! != "undefined"
                    ? PublishedAddress.FaxNumber!
                    : ""
                }
                onChange={updateInput}
              />
              <label
                className="form-label"
                htmlFor="PublishedAddress.FaxNumber"
              >
                Fax Number
              </label>
            </div>

            <div className="input-field-div-wrapper">
              {/* <Label>Email ID</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.Email"
                {...register("PublishedAddress.Email", {
                  // required: "Email is a required field",
                })}
                value={
                  typeof PublishedAddress.Email! != "undefined"
                    ? PublishedAddress.Email!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
              />
              <label className="form-label" htmlFor="PublishedAddress.Email">
                Email ID
              </label>
              <p className="form-error form-error-position">
                {errors.PublishedAddress?.Email?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper">
              {/* <Label>Firm Admin Name</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.FirmAdminName"
                name="PublishedAddress.FirmAdminName"
                readOnly={true}
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.Zipcode?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                value={
                  typeof PublishedAddress.FirmAdminName! != "undefined"
                    ? PublishedAddress.FirmAdminName!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
                onClick={() =>
                  alert("Admin Name can be edited only in settings page.")
                }
              />
              <label
                className="form-label"
                htmlFor="PublishedAddress.FirmAdminName"
              >
                Firm Admin Name
              </label>
            </div>
            <div className="input-field-div-wrapper">
              {/* <Label>Admin Phone Number</Label> */}
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.FirmAdminPhoneNumber"
                name="PublishedAddress.FirmAdminPhoneNumber"
                readOnly={true}
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.Zipcode?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                type="text"
                pattern="[0-9]*"
                value={
                  typeof PublishedAddress.FirmAdminPhoneNumber! != "undefined"
                    ? PublishedAddress.FirmAdminPhoneNumber!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
                onClick={() =>
                  alert(
                    "Admin Phone number can be edited only in settings page."
                  )
                }
              />
              <label
                className="form-label"
                htmlFor="PublishedAddress.FirmAdminPhoneNumber"
              >
                Admin Phone Number
              </label>
            </div>
            <div className="input-field-div-wrapper">
              <Label>Admin Email ID</Label>
              <input
                className="input-field-div-small"
                placeholder=""
                id="PublishedAddress.FirmAdminEmailId"
                name="PublishedAddress.FirmAdminEmailId"
                readOnly={true}
                // disabled={
                //   disablePubAddressInputField
                //     ? errors.PublishedAddress?.Zipcode?.message != null
                //       ? false
                //       : true
                //     : false
                // }
                value={
                  PublishedAddress && PublishedAddress.FirmAdminEmailId
                    ? PublishedAddress.FirmAdminEmailId!
                    : ""
                }
                autoComplete="off"
                onChange={updateInput}
                onClick={() =>
                  alert("Admin EmailID can be edited only in settings page.")
                }
              />
              <label
                className="form-label"
                htmlFor="PublishedAddress.FirmAdminEmailId"
              >
                Admin Email ID
              </label>
            </div>
          </div>
        </div>
      </>
      {/* <ReactModal
        isOpen={addFirmModelOpen || editFirmModelOpen}
        onRequestClose={() => {
          setAddFirmModelOpen(false);
          setEditFirmModelOpen(false);
        }}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        <AddEditFirm
          mode={addFirmModelOpen ? "Add Firm" : "Edit Firm"}
          StateList={props.StateList}
          callBackClose={() => {
            getFirmDetailList();
            setAddFirmModelOpen(false);
            setEditFirmModelOpen(false);
            console.log("addFirmModelOpen:", addFirmModelOpen);
          }}
        />
      </ReactModal> */}
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default CreateMemberAddress;
